/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-return-assign */
import qs from 'query-string';
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Swal from 'sweetalert2';
import Loader from '../../Component/Common/Loader';
import UserService from '../../Service/UserService';
import PageHeader from '../Common/PageHeader';
import Table from '../Common/Table';
import NoAccess from '../NoAccess/index';
import Filter from './Filter';

class Customers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_forceRender: false,
			_isLoading: false,
			_customFilterQuery: ''
		};
	}

	forceRenderTable = () => {
		this.setState({
			_forceRender: !this.state._forceRender
		});
	};

	dataSource = async queryUrl => {
		return UserService.getAllUsers(queryUrl);
	};

	deactivateUser = async id => {
		const requestBody = {
			path: 'active',
			value: false
		};

		this.setState({ _isLoading: true });
		try {
			const response = await UserService.updateStatus(id, requestBody);
			this.setState({ _isLoading: false });
			if (response.data?.status) {
				this.toastWhenSuccess('suspended');
				this.forceRenderTable();
			} else {
				this.toastWhenFail(response.message);
			}
		} catch (err) {
			this.setState({ _isLoading: false });
			console.log(err);
		}
	};

	activateUser = async id => {
		const requestBody = {
			path: 'active',
			value: true
		};
		try {
			this.setState({ _isLoading: true });
			const response = await UserService.activateUser(id, requestBody);

			this.setState({ _isLoading: false });
			if (response.data?.status) {
				this.forceRenderTable();
				this.toastWhenSuccess('activated');
			} else {
				this.toastWhenFail(response.message);
			}
		} catch (err) {
			this.setState({ _isLoading: false });
			console.log(err);
		}
	};

	toastWhenFail = resp => {
		Swal.fire({
			title: 'Sorry!',
			text: resp,
			// icon: 'error',
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			customClass: 'otp_message_success'
		});
	};

	toastWhenSuccess = resp => {
		Swal.fire({
			animation: false,

			title: 'Congratulations!',
			text: `You have succesfully ${resp} the customer.`,
			icon: 'success',
			customClass: 'otp_message_success'
		});
	};

	confirmYes = (id, name) => {
		Swal.fire({
			animation: false,
			showCancelButton: true,
			confirmButtonText: 'Yes',
			title: 'Confirm Suspend!',
			text: `Are you sure you want to suspend the LendAmi Account of ${name} ?`,
			icon: 'success',
			customClass: 'otp_message_success'
		}).then(res => {
			if (res.value) {
				this.deactivateUser(id);
			}
		});
	};

	onResetFilter = () => {
		const queryItems = qs.parse(window.location.search);
		queryItems.globalSearch = '';
		queryItems.page = 0;
		this.props.history.push({
			search: qs.stringify(queryItems)
		});
		this.setState({
			_customFilterQuery: ''
		});
	};

	onSearch = (query, changePage = true) => {
		const queryItems = qs.parse(window.location.search);
		queryItems.globalSearch = query;
		queryItems.page = changePage ? 0 : queryItems.page;
		this.props.history.push({
			search: qs.stringify(queryItems)
		});
		const queryUrl = `filter=${query}`;
		this.setState({
			_customFilterQuery: queryUrl
		});
	};

	render() {
		// NOSONAR

		if (!this.props.authorized) {
			return <NoAccess />;
		}

		const columns = [
			{
				name: 'id',
				label: 'id',
				options: {
					filter: true,
					sort: true,
					display: false
				}
			},
			{
				name: 'tenant_full_name',
				label: 'Tenant',
				options: {
					filter: true,
					sort: true
				}
			},
			{
				name: 'first_name',
				label: 'First Name',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (value, tableMeta) => {
						const customerId = tableMeta.rowData[0];
						return <Link to={`/admin/customer/${customerId}`}>{value}</Link>;
					}
				}
			},
			{
				name: 'last_name',
				label: 'Last Name',
				options: {
					filter: true,
					sort: true
				}
			},
			{
				name: 'email',
				label: 'Email',
				options: {
					filter: true,
					sort: false
				}
			},
			{
				name: 'phone',
				label: 'Mobile Number',
				options: {
					filter: true,
					sort: true,
					customBodyRender: value => {
						if (value !== undefined) {
							return <span className="bold-important">{value}</span>;
						}
					}
				}
			},
			{
				name: 'city',
				label: 'City',
				options: {
					filter: true,
					sort: true,
					display: false
				}
			},

			{
				name: 'state',
				label: 'Region',
				options: {
					filter: true,
					sort: true,
					display: false
				}
			},
			{
				name: 'postal_code',
				label: 'Postal Code',
				options: {
					filter: true,
					sort: true,
					display: false,
					customBodyRender: value => {
						if (value !== undefined) {
							return <span className="bold-important">{value}</span>;
						}
					}
				}
			},
			{
				name: 'address',
				label: 'Address',
				options: {
					filter: false,
					sort: false,
					customBodyRender: (value, obj) => {
						if (value !== undefined) {
							return (
								<>
									{value !== '' ? value + ', ' : ''}
									{obj.rowData[6] !== null ? obj.rowData[6] : ''}
									{obj.rowData[6] === null ? obj.rowData[7] : ', ' + obj.rowData[7]}
									{obj.rowData[8] !== null ? ', ' + obj.rowData[7] : ''}
								</>
							);
						}
					}
				}
			},
			{
				name: 'active_loans',
				label: 'Active Loans',
				options: {
					filter: true,
					sort: true,
					customBodyRender: value => {
						if (value !== undefined) {
							return <span className="bold-important">{value}</span>;
						}
					}
				}
			},
			{
				name: 'active',
				label: 'Action',
				options: {
					sort: false,
					customBodyRender: (value, obj) => {
						const customerId = obj.rowData[0];
						const full_name = `${obj.rowData[2]} ${obj.rowData[3]}`;
						if (value !== undefined) {
							if (value === true) {
								return (
									<div className="view_btn">
										<>
											<button
												className="btn btn-block btn-outline-danger btn-xs"
												onClick={() => {
													this.confirmYes(customerId, full_name);
													// this.deactivateUser(obj.rowData[0]);
												}}
												type="button">
												Suspend
											</button>

											<Link to={`/admin/customer/custom-view/${customerId}`}>View</Link>

											<button
												className="btn btn-block btn-outline-danger btn-xs"
												onClick={() => {
													window.location.href = `/admin/transactions/${customerId}?globalSearch=${full_name}&page=0`;
													// this.deactivateUser(obj.rowData[0]);
												}}
												type="button">
												Transaction
											</button>
										</>
									</div>
								);
							} else {
								return (
									<button
										className="btn btn-block btn-outline-primary btn-xs"
										onClick={() => {
											this.activateUser(obj.rowData[0]);
										}}
										type="button">
										Resume
									</button>
								);
							}
						}
					}
				}
			}
		];

		return (
			<>
				<PageHeader text={'Customers'} />
				<Table
					columns={columns}
					customFilterQuery={this.state._customFilterQuery}
					dataSourceHandler={this.dataSource}
					dataSourceName="users"
					forceRender={this.state._forceRender}
					sort
					title={<Filter onResetFilter={this.onResetFilter} onSearch={this.onSearch} />}
				/>
				{this.state._isLoading ? <Loader /> : null}
			</>
		);
	}
}

export default withRouter(Customers);
